import { AbstractHttpClient, AbstractTokenManager, stringifyQueries } from "@clairejs/client";
import { Register } from "@clairejs/core";

import { CreateSessionBody, CreateSessionResponse } from "../../dto/http/user";

@Register()
export class SessionApi {
    constructor(private readonly http: AbstractHttpClient, private readonly tokenManager: AbstractTokenManager) {}

    async createSession(body: CreateSessionBody, query?: Record<string, string>) {
        const result = await this.http.post<CreateSessionResponse>(
            `/session?${stringifyQueries(query || {})}`,
            body,
            {},
            { noAuthorization: true },
        );

        if (result?.accessToken) {
            await this.tokenManager.setAccessToken(result.accessToken);
        }

        return result;
    }

    async tfaSession(code: string) {
        return await this.http.post<CreateSessionResponse>("/session/tfa", {
            code,
        });
    }
}
